(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["p-filters"] && !Shopify.designMode) return;
  try {
    // Accordion toggling (mobile only). Delegated on document so it keeps
  // working after facets.js morphs the section markup.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-popup-facet-toggle]');
    if (!trigger) return;
    if (window.matchMedia('(min-width: 1024px)').matches) return;

    const group = trigger.closest('[data-popup-facet]');
    const isOpen = group.classList.toggle('popup-facet--open');
    trigger.setAttribute('aria-expanded', String(isOpen));
  });
  } catch(e) { console.error(e); }
})();

})();
